import { render, staticRenderFns } from "./IdentityCertification.vue?vue&type=template&id=07ad7a70&scoped=true"
import script from "./IdentityCertification.vue?vue&type=script&lang=js"
export * from "./IdentityCertification.vue?vue&type=script&lang=js"
import style0 from "./IdentityCertification.vue?vue&type=style&index=0&id=07ad7a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ad7a70",
  null
  
)

export default component.exports